import { accessRole } from "../../../../helpers/access_role"

import React, { Fragment, useState, useRef, useEffect } from "react"
import apiResponse from "../../../../services/apiResponse"

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Input
} from "reactstrap"

import IndexBloc from "./Blocs/IndexBlock"

import Select from "react-select"

import TableActiveComponent from './Components/TableActiveComponent'

let peg_uuid = JSON.parse(localStorage.getItem('userdata')) != null ? JSON.parse(localStorage.getItem('userdata')).employee_uuid : "";
let peg_nip = JSON.parse(localStorage.getItem('userdata')) != null ? JSON.parse(localStorage.getItem('userdata')).employee_nip : "";
let peg_name = JSON.parse(localStorage.getItem('userdata')) != null ? JSON.parse(localStorage.getItem('userdata')).employee_full_name : "";
let peg_jabatan = JSON.parse(localStorage.getItem('userdata')) != null ? JSON.parse(localStorage.getItem('userdata')).employee_current_position_name : "";
let peg_unit = JSON.parse(localStorage.getItem('userdata')) != null ? JSON.parse(localStorage.getItem('userdata')).employee_current_work_unit_name : "";

var reformatOptionsWU = function(workUnits) {
  return workUnits.map(function(workUnit) {
    var newObj = {};
    newObj["label"] = workUnit.work_unit_name_tabs;
    newObj["value"] = workUnit.work_unit_uuid;

    return newObj;
  });
};
var reformatOptionsStatus = function(EmployeeStatuss) {
    return EmployeeStatuss.map(function(EmployeeStatus) {
      var newObj = {};
      newObj["label"] = EmployeeStatus.employee_status_name;
      newObj["value"] = EmployeeStatus.employee_status_uuid;
  
      return newObj;
    });
  };
const IndexView = (props) => {
  
    let indexBloc = new IndexBloc();

    const [activeTab, setactiveTab] = useState("1")    
    const activeRef = useRef();
    const inactiveRef = useRef();

    // Select
    const [optionUnits, setOptionUnits] = useState([
    ]);
    const [optionEmployeeStatuss, setOptionEmployeeStatus] = useState([
    ]);
    const [selectedUnit, setSelectedUnit] = useState("")
    const [selectedStatus, setSelectedStatus] = useState({
      label : "PNS",
      value : "2920a911-9b3f-42cf-ad91-d05cb4ab057b"
    })

    const handleSelectUnit = (selectedUnit) => {
      setSelectedUnit(selectedUnit)
    }
    const handleSelectStatus = (selectedStatus) => {
        setSelectedStatus(selectedStatus)
    }
    useEffect( () => {
        // get data unit
        indexBloc.workUnitChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response.result
                        setOptionUnits(
                          reformatOptionsWU(response)
                        )
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        indexBloc.EmployeeStatusChannel.subscribe((result) => {
          switch (result.status) {
              case apiResponse.COMPLETED:
                  if(result.data.status) {
                      let response = result.data.response.result
                      setOptionEmployeeStatus(
                          reformatOptionsStatus(response)
                      )
                  }
                  break
              case apiResponse.ERROR:
                  
                  break
              default:
                  break
          }
      })
  
      indexBloc.fetchWorkUnit({})
      indexBloc.fetchEmployeeStatus({})
    }, [])

    // Filter
    const [nip, setNip] = useState('')
    const [name, setName] = useState('')

    let additionalFilter = {
        nip: nip,
        name: name,
        work_unit: selectedUnit.value || "",
        employee_status_uuid: selectedStatus.value || ""
    };

    const reloadActiveRef = () => activeRef.current.setTokenAPI()
    const reloadInactiveRef = () => inactiveRef.current.setTokenAPI()

    function handleButtonSearch() {
      reloadActiveRef()
    }

    function handleButtonReset() {
      setNip('');
      setName('');
      setSelectedUnit('')
      setSelectedStatus('')
      reloadActiveRef()
    }

    return (
        <Fragment>
            <Container fluid>
                <Row>
                    <Col xs="12">
                        
                        <Card>
                            <CardBody>
                                <div className="float-end">
                                {/* {
                                    (accessRole('create')) ?
                                        <Link to="home.html?create">
                                            <Button color="primary">New Sample</Button>
                                        </Link>
                                    : null
                                } */}
                                </div>
                                <CardTitle>List Data Tunjangan Kinerja</CardTitle>
                                <CardSubtitle className="mb-3">
                                    Daftar Tunjangan Kinerja
                                </CardSubtitle>
                                <hr />

                                <Row className="mb-2">
                                    <label
                                        htmlFor="fielCode"
                                        className="col-md-2 col-form-label"
                                    >
                                    NIP
                                    </label>
                                    <Col md="3">
                                        {peg_nip}
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <label
                                        htmlFor="fielCode"
                                        className="col-md-2 col-form-label"
                                    >
                                    Nama
                                    </label>
                                    <Col md="4">
                                        {peg_name}
                                    </Col>
                                </Row>
                                {/* <Row className="mb-3">
                                    <label
                                        htmlFor="gender"
                                        className="col-md-2 col-form-label"
                                    >
                                    Status Pegawai
                                    </label>
                                    <Col md="4">
                                        <Select
                                            value={optionEmployeeStatuss.filter(option => 
                                              option.value === selectedStatus.value)}
                                            onChange={handleSelectStatus}
                                            required="required"
                                            options={optionEmployeeStatuss}
                                            classNamePrefix="select2-unit"
                                        />
                                    </Col>
                                </Row> */}
                                {/* <Row className="mb-3">
                                    <label
                                        htmlFor="gender"
                                        className="col-md-2 col-form-label"
                                    >
                                    Unit Kerja
                                    </label>
                                    <Col md="4">
                                        <Select
                                            value={optionUnits.filter(option => 
                                              option.value === selectedUnit.value)}
                                            onChange={handleSelectUnit}
                                            required="required"
                                            options={optionUnits}
                                            classNamePrefix="select2-unit"
                                        />
                                    </Col>
                                </Row> */}
                               
                                <Row className="mb-3">
                                    <Col md="2"></Col>
                                    <Col md="10">
                                        <Button 
                                            color="primary" 
                                            type="button"
                                            onClick={() => {
                                                handleButtonSearch()
                                            }}
                                        >
                                            <i className="uil-search-alt"></i> Cari
                                        </Button>
                                        {' '}
                                        <Button 
                                          color="warning" 
                                          type="button"
                                          onClick={() => {
                                              handleButtonReset()
                                          }}>
                                            <i className="uil-refresh"></i> Reset
                                        </Button>
                                    </Col>
                                </Row>

                                <hr />
                                
                                <TableActiveComponent ref={activeRef} uuid={peg_uuid} handleInactiveSuccess={reloadInactiveRef} additionalFilter={additionalFilter}/>
                            </CardBody>
                        </Card>
                        
                       
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default IndexView